/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'ai-mate.chat-error-banner.description': 'Your chat history is saved up to 30 days.',
  'ai-mate.chat-error-banner.title': 'Start new chat',
  'ai-mate.chat-error.description': 'Try <btn>reload chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'You have reached the maximum number of requests. Please try again later.',
  'ai-mate.chat-error.rate-limited-title': 'Too many requests',
  'ai-mate.chat-error.rovo-inactive-description':
    "Looks like Rovo isn't enabled on your site. <link>Setting up Rovo</link>",
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo is inactive',
  'ai-mate.chat-error.title': "We're not sure what went wrong",
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Ask AI about this',
  'highlight-actions.rovo-chat-explain-option.text': 'Explain',
  'highlight-actions.rovo-chat-explain-prompt':
    'Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definition to any technical terminology use in the original phrasing: {selectedText}',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Find resources',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Find resources within organizational knowledge only that supports the statements made: {selectedText}',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Give examples',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more: {selectedText}',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Give feedback',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chat recommendations',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Open Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Summarize',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Highlight the key points from the selected text, focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Scroll left',
  'horizontal-scroll-container.scroll-right': 'Scroll right',
};
